var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-switch cog-toggle cog-input",
      class: { "cog-switch--condensed cog-toggle--condensed": _vm.isCondensed }
    },
    [
      _vm.readonly
        ? _c("div", { staticClass: "is-read-only" }, [
            _vm._v(_vm._s(_vm.displayValue || " "))
          ])
        : [
            !_vm.chameleon
              ? [
                  _c("el-switch", {
                    ref: "switch",
                    attrs: {
                      id: "cog-" + _vm.$parent.$source.id,
                      name: _vm.$parent.$source.label,
                      "active-text": _vm.activeText,
                      "inactive-text": _vm.inactiveText
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.internalValue,
                      callback: function($$v) {
                        _vm.internalValue = $$v
                      },
                      expression: "internalValue"
                    }
                  }),
                  _vm._v(" "),
                  _vm.isCondensed
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "cog-switch__condensed-label cog-toggle__condensed-label cog-helptext",
                          class: { "is-active": _vm.internalValue }
                        },
                        [_vm._v(_vm._s(_vm.displayValue))]
                      )
                    : _vm._e()
                ]
              : _c(
                  "div",
                  { staticClass: "cog-switch--native cog-toggle--native" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "cog-switch__left-label cog-toggle--left-label",
                        on: {
                          click: function($event) {
                            return _vm.handleChange(false, $event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.inactiveText))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.numericValue,
                          expression: "numericValue"
                        }
                      ],
                      attrs: {
                        id: "cog-" + _vm.$parent.$source.id,
                        type: "range",
                        min: "0",
                        max: "1"
                      },
                      domProps: { value: _vm.numericValue },
                      on: {
                        change: _vm.handleNativeChange,
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar"
                            ])
                          )
                            return null
                          $event.preventDefault()
                          return _vm.handleChange(!_vm.internalValue, $event)
                        },
                        __r: function($event) {
                          _vm.numericValue = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "cog-switch__right-label cog-toggle--right-label",
                        on: {
                          click: function($event) {
                            return _vm.handleChange(true, $event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.activeText))]
                    )
                  ]
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }